module.exports = __webpack_public_path__ + "static/img/classify_exp.e5fc39ad.jpg";